<template>
  <div class="container-villasis" data-scroll="scroll">    
    <div class="container">    
      <div class="row">
        <div class="col-12 p-0">
          <div class="" :ref="uid" :id="`container_scroll_${uid}`">

            <div class="">
              <div class="container">
                <div class="row justify-content-center">
                  <div class="col-12 col-md-6 text-right">
                    <div class="sticky-villasis">
                      <div :id="i.id" v-for="(i, ix) in imagesScroll" :key="ix"  class="item-tweet mb-5" :data-card="ix" :class="{'current': i.class }">
                        <ImageElement :imageData="imageDataScroll(i)" :class="{'active': i.class }" />
                    </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 text-left">
                    <div :id="`item-trigger-${ix}`" v-for="(i, ix) in cardTexts" :key="ix" class="item-villasis item-trigger" :data-card="ix">
                      <div v-if="i.text" :class="i.position">
                        <div v-html="i.text"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div> 
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

  @keyframes slideTweet {
    from {
      opacity: 0;
      
    }
    
    to {
      opacity: 1;
    }
  }
  
  @keyframes tweetHighlight {
    from {
      opacity: 0;
      margin-top: 25px;
      box-shadow: none;
    }
    
    to {
      opacity: 1;
      margin-top: 0px;
      box-shadow: 0px 0px 12px 2px #fff600f0;
    }
  }

  .sticky-villasis {
    position: relative;
    margin: 45px 0;

    @media screen and (max-width: 767px) {
      position: fixed;
      top: 0;
      margin: 0;
      left: 18%;
      width: 80%;
    }
  }
  
  .item-tweet {
    position: absolute;
    top: 0;
    right: 10%;
    text-align: center;
    width: 100%;
    max-width: 400px;
    margin: 0 auto 225px auto;
    display: inline-block;
    transform: rotate(-2deg);
    background-color: #fff;
    padding: 15px;
    border: solid 2px #c85fe5;
    opacity: 0;

    &.active {
      opacity: 1;
    }

    img {
      opacity: 0.5;

      &.active {
        animation: slideTweet 0.75s normal forwards ease-in-out;
        opacity: 1;
      }

      &.out {
        opacity: 0.5 !important;
      }
    }

    &.current {
      animation: tweetHighlight 0.75s normal forwards ease-in-out;
    }

    &:first-child {
      top: 15vh;
      transform: scale(1) rotate(-5deg);
      @media screen and (max-width: 767px) {
        top: 45vh;
      }
    }
    &:nth-child(2) {
      top: 25vh;
      transform: scale(1) rotate(5deg);
      @media screen and (max-width: 767px) {
        top: 15vh;
      }
    }
    &:nth-child(3) {
      top: 55vh;
      transform: scale(1) rotate(-5deg);
      @media screen and (max-width: 767px) {
        top: 35vh;
      }
    }
    &:nth-child(4) {
      top: 90vh;
      transform: scale(1) rotate(5deg);
      @media screen and (max-width: 767px) {
        top: 15vh;
      }
    }
  }

  .container-villasis {
    background-color: #0f0f0f;
    color: #fff;
    margin-top: 55px;
    clip-path: fill-box;

    @media screen and (max-width: 767px) {
      margin-top: 35px;
    }
  }

  .item-villasis {
    width: 100%;
    text-align: left;
    margin: 55px auto 35px auto;
    font-size: 21px;

    @media screen and (max-width: 767px) {
      margin: 55vh auto;
    }

    .left {
      padding: 15px;
      background: #161616;
    }

    &:first-child {
      margin-top: 125px;
    }

  }

</style>

<script>

  import images from '@/mixins/images'

  export default {
    name: 'ScrollText',
    mixins: [images],
    data() {
      return {
        currentId: `item-trigger-init`,
        uid: this._uid,
        cardTexts: [
        {"item_type": "ScrollData", "item_id": 56, "text": "El 29 de octubre de 2023, la periodista Graciela Villasís, jefa de la Unidad de Investigación del diario <i>El Comercio</i>, publicó en su cuenta de X que “los procesos disciplinarios contra fiscales que investigan casos emblemáticos y la reducción de su personal afectan y debilitan sus pesquisas”.", "imgAlt": "", "imageBg": "", "groupby": 56, "imageCredits": "", "position": "left"},
        {"item_type": "ScrollData", "item_id": 57, "text": "Villasís hacía referencia a un hecho público: Benavides estaba desarticulando y abriendo procesos disciplinarios a fiscales que no eran afines a ella y que estaban a cargo de megacasos como “Lava Jato” y “Los Cuellos Blancos”.", "imgAlt": "", "imageBg": "", "groupby": 56, "imageCredits": "", "position": "left"},
        {"item_type": "ScrollData", "item_id": 581, "text": "Una hora después del <i>post</i> de la periodista, el Ministerio Público respondió en la misma red social con la etiqueta de “FALSO”. De acuerdo con la versión institucional, esta medida se estaba tomando “para cumplir con el requisito legal del Código Procesal Penal”, deslindando así cualquier responsabilidad directa de la fiscal de la Nación.", "imgAlt": "", "imageBg": "", "groupby": 56, "imageCredits": "", "position": "left"},
        {"item_type": "ScrollData", "item_id": 58, "text": " Acto seguido, Villasís replicó el desmentido, ratificándose en su información y citando nuevos casos afectados por las decisiones de Benavides, como “Los niños” y “Tarata”.", "imgAlt": "", "imageBg": "", "groupby": 56, "imageCredits": "", "position": "left"},
        {"item_type": "ScrollData", "item_id": 58, "text": "Por si fuera poco, la cuenta oficial del Ministerio Público volvió a etiquetar como “FALSO” el nuevo tuit de Villasís sin ofrecer mayor explicación. Solo señalaba que esta acción no correspondía a la máxima autoridad de la institución. El intercambio de desmentidos, que parecía orientado a desacreditar el ejercicio periodístico, alcanzó cerca de 70 mil reproducciones.", "imgAlt": "", "imageBg": "", "groupby": 56, "imageCredits": "", "position": "left"}
        ],
        imagesScroll: [
          {
            id: `item-trigger-init`,
            class: `active`,
            alt: `/tweets/villasis_scroll/1.png`,
            imageBg: `/tweets/villasis_scroll/1.png`
          },
          {
            id: `item-trigger-2`,
            alt: `/tweets/villasis_scroll/2.png`,
            imageBg: `/tweets/villasis_scroll/2.png`
          },
          {
            id: `item-trigger-3`,
            alt: `/tweets/villasis_scroll/3.png`,
            imageBg: `/tweets/villasis_scroll/3.png`
          },
          {
            id: `item-trigger-4`,
            alt: `/tweets/villasis_scroll/4.png`,
            imageBg: `/tweets/villasis_scroll/4.png`
          }
        ]
      }
    },
    props: {
      cardText: Array
    },
    mounted() {
      this.$nextTick(() => {
        this.initScroll();
      });
    },
    computed: {
      observer() {
        return new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            let imgID = entry.target.id
            let containerImgTweet = document.querySelector(`#${imgID}`)
            let imgTweet = document.querySelector(`#${imgID} img`)

            if (entry.isIntersecting) {
              entry.target.classList.add('active')
              imgTweet.classList.add('active')
              containerImgTweet.classList.add('current')
              this.currentId = imgID
            } else {
              if(window.innerWidth > 720) {
                entry.target.classList.remove('active')
                containerImgTweet.classList.remove('current')
              }
            }
          });
        }, { threshold: 0.5});
      }
    },
    methods: {
      initScroll() {
        // Observe all scroll sections
        document.querySelectorAll('.item-villasis').forEach((section, ix) => {
          this.observer.observe(section, ix)
        });
      }
    }
  }
</script>
